import Card from './Card.jsx';
import './Card.css';

export default Card;
